import React, { useState } from 'react'
import Box from '@mui/material/Box'
import CustomAutoComplete from '../../../components/CustomAutoComplete'
import type { PlatformListType } from '../types'
import { useAppDispatch } from '../../../reducers/hooks'
import { userReducer } from '../../../reducers/user/userReducer'

interface BotTypeProps {
  platformList: PlatformListType[]
  setSelectedBotType: React.Dispatch<React.SetStateAction<string | null>>
}

const BotTypeDropDown: React.FC<BotTypeProps> = ({ platformList, setSelectedBotType }): JSX.Element => {
  const [selectedPlatform, setSelectedPlatform] = useState<PlatformListType | null>(null)
  const dispatch = useAppDispatch()

  const handleAutocompleteChange = (event: any, newValue: PlatformListType | null): void => {
    setSelectedPlatform(newValue)
    if (newValue !== null) {
      dispatch(userReducer.actions.changeBotType(newValue.value))
      localStorage.setItem('botType', newValue.value)
      setSelectedBotType(newValue.value)
    }
  }

  return (
    <>
      <Box mb={2} mt={2}>
        <CustomAutoComplete
          options={platformList}
          getOptionLabel={(platformList) => `${platformList.platform}`}
          value={selectedPlatform}
          onChange={handleAutocompleteChange}
          placeholder="Select Platform"
        />
      </Box>
    </>
  )
}

export default BotTypeDropDown
